import { GpsFixed, GpsNotFixed } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";

import { FramerTooltip } from "@ryde/controls";
import {
  investigationFollowVehicleAtom,
  TOOLTIP_DELAY_BUTTONS,
} from "@ryde/shared";

import { RIDE_INVESTIGATION_E2E } from "../investigation.constants";

/** Transport-bar switch for the follow-the-vehicle camera (on by default, off after a manual pan). */
export const InvestigationFollowToggle: FC = () => {
  const { t } = useTranslation();
  const [isFollowing, setIsFollowing] = useRecoilState(
    investigationFollowVehicleAtom,
  );
  const label = t("rideMap.investigation.transport.followVehicle");

  return (
    <FramerTooltip
      content={
        isFollowing
          ? t("rideMap.investigation.transport.followVehicleOff")
          : label
      }
      mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
    >
      <IconButton
        size="small"
        color={isFollowing ? "primary" : "default"}
        onClick={() => setIsFollowing(value => !value)}
        aria-label={label}
        aria-pressed={isFollowing}
        data-e2e={RIDE_INVESTIGATION_E2E.followToggle}
      >
        {isFollowing ? <GpsFixed /> : <GpsNotFixed />}
      </IconButton>
    </FramerTooltip>
  );
};
